"use client";

import { usePathname } from 'next/navigation';
import ServiceWorkerRegistration from './ServiceWorkerRegistration';
import FacebookSDK from './FacebookSDK';
import Navigation from './Navigation';
import Footer from './Footer';
import AnalyticsScripts from './AnalyticsScripts';
import SchemaMarkup from './SchemaMarkup';

export default function ClientLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // Define which pages need the Facebook SDK
  const pagesWithFacebook = [
    '/social-media',
    // Add any other paths where Facebook components are used
  ];

  // Check if current page needs Facebook SDK
  const needsFacebookSDK = pagesWithFacebook.some(page => pathname?.startsWith(page));

  return (
    <>
      {/* Structured data for SEO visibility improvement */}
      <SchemaMarkup />

      {/* Analytics scripts for visitor tracking */}
      <AnalyticsScripts />

      <ServiceWorkerRegistration />
      <FacebookSDK shouldInitialize={needsFacebookSDK} />
      <Navigation />
      <main className="flex-grow">{children}</main>
      <Footer />
    </>
  );
}